var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.25 31.5C24.9485 31.5 32 24.4485 32 15.75C32 7.05152 24.9485 0 16.25 0C7.55152 0 0.5 7.05152 0.5 15.75C0.5 24.4485 7.55152 31.5 16.25 31.5Z",
    fill: "url(#paint0_linear_99_215)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.62934 15.5837C12.2208 13.5833 15.2825 12.2645 16.8144 11.6273C21.1883 9.80802 22.0972 9.49199 22.6896 9.48156C22.8199 9.47926 23.1112 9.51155 23.2999 9.66467C23.4592 9.79396 23.5031 9.96862 23.5241 10.0912C23.545 10.2138 23.5712 10.493 23.5504 10.7112C23.3134 13.2017 22.2878 19.2453 21.766 22.0347C21.5452 23.2149 21.1105 23.6107 20.6896 23.6494C19.775 23.7336 19.0805 23.045 18.1946 22.4643C16.8084 21.5556 16.0253 20.9899 14.6797 20.1032C13.1247 19.0785 14.1328 18.5153 15.019 17.5948C15.2509 17.354 19.2808 13.6885 19.3588 13.356C19.3685 13.3144 19.3776 13.1593 19.2855 13.0775C19.1934 12.9956 19.0575 13.0236 18.9594 13.0459C18.8204 13.0774 16.6059 14.5411 12.3159 17.437C11.6874 17.8686 11.118 18.0789 10.6079 18.0679C10.0456 18.0557 8.96381 17.7499 8.15965 17.4885C7.1733 17.1679 6.38937 16.9984 6.45763 16.4538C6.49319 16.1702 6.88376 15.8802 7.62934 15.5837Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_99_215",
    x1: 16.25,
    y1: 0,
    x2: 16.25,
    y2: 31.2664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.5,
    height: 31.5,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.da1d076a55071a14eb9a76c295d6ab11.svg";
export { ForwardRef as ReactComponent };